export const COMMON = "#FFCCCC"    // 共通
export const UNCOMMON = "#FFFF99"  // 非共通
export const UNRELATED = "#FFFFFF" // 対象外
export const NOTCOUNT = "#404040"  // 交差点形状でそもそも押せないボタン

export const defaultCountList = () => {
    return [
        [
            {type: 'blank'},
            {type: 'landscape-data-top', row: [
                [
                    {type: 'car', direction: 'top_left', key: 'top_car_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'top_bottom', key: 'top_car_bottom', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'top_right', key: 'top_car_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'people', direction: 'top_left', key: 'top_people_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'top_bottom', key: 'top_people_bottom', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'top_right', key: 'top_people_right', val: 0, bgColor: UNRELATED, locked: false },
                ]
            ]},
            {type: 'common_uncommon', car: 'true', people: 'true' },
        ],
        [
            {type: 'portrait-data-left', row: [
                [
                    {type: 'car', direction: 'left_top', key: 'left_car_top',val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'left_top', key: 'left_people_top',val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'left_right', key: 'left_car_right', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'left_right', key: 'left_people_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'left_bottom', key: 'left_car_bottom', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'left_bottom', key: 'left_people_bottom', val: 0, bgColor: UNRELATED, locked: false },
                ],
            ]},
            {type: 'intersection'},
            {type: 'portrait-data-right', row: [
                [
                    {type: 'people', direction: 'right_top', key: 'right_people_top', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'right_top', key: 'right_car_top', val: 0, bgColor: UNRELATED, locked: false }
                ],
                [
                    {type: 'people', direction: 'right_left', key: 'right_people_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'right_left', key: 'right_car_left', val: 0, bgColor: UNRELATED, locked: false }
                ],
                [
                    {type: 'people', direction: 'right_bottom', key: 'right_people_bottom', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'right_bottom', key: 'right_car_bottom', val: 0, bgColor: UNRELATED, locked: false }
                ]
            ]},
        ],
        [
            {type: 'color'},
            {type: 'landscape-data-bottom', row: [
                [
                    {type: 'people', direction: 'bottom_left', key: 'bottom_people_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'bottom_top', key: 'bottom_people_top', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'bottom_right', key: 'bottom_people_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'bottom_left', key: 'bottom_car_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'bottom_top', key: 'bottom_car_top', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'bottom_right', key: 'bottom_car_right', val: 0, bgColor: UNRELATED, locked: false },
                ]
            ]},
            {type: 'icon'},
        ]
    ]
}

export const carCountList = () => {
    return [
        [
            {type: 'blank'},
            {type: 'landscape-data-top', row: [
                [
                    {type: 'car', direction: 'top_left', key: 'top_car_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'top_bottom', key: 'top_car_bottom', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'top_right', key: 'top_car_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
            ]},
            {type: 'common_uncommon', car: 'true', people: 'false' },
        ],
        [
            {type: 'portrait-data-left', row: [
                [
                    {type: 'car', direction: 'left_top', key: 'left_car_top',val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'left_right', key: 'left_car_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'left_bottom', key: 'left_car_bottom', val: 0, bgColor: UNRELATED, locked: false },
                ],
            ]},
            {type: 'intersection'},
            {type: 'portrait-data-right', row: [
                [
                    {type: 'car', direction: 'right_top', key: 'right_car_top', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'right_left', key: 'right_car_left', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'car', direction: 'right_bottom', key: 'right_car_bottom', val: 0, bgColor: UNRELATED, locked: false },
                ]
            ]},
        ],
        [
            {type: 'color'},
            {type: 'landscape-data-bottom', row: [
                [
                    {type: 'car', direction: 'bottom_left', key: 'bottom_car_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'bottom_top', key: 'bottom_car_top', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'car', direction: 'bottom_right', key: 'bottom_car_right', val: 0, bgColor: UNRELATED, locked: false },
                ]
            ]},
            {type: 'icon'},
        ]
    ]
}

export const peopleCountList = () => {
    return [
        [
            {type: 'blank'},
            {type: 'landscape-data-top', row: [
                [
                    {type: 'people', direction: 'top_left', key: 'top_people_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'top_bottom', key: 'top_people_bottom', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'top_right', key: 'top_people_right', val: 0, bgColor: UNRELATED, locked: false },
                ]
            ]},
            {type: 'common_uncommon', car: 'false', people: 'true' },
        ],
        [
            {type: 'portrait-data-left', row: [
                [
                    {type: 'people', direction: 'left_top', key: 'left_people_top',val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'people', direction: 'left_right', key: 'left_people_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
                [
                    {type: 'people', direction: 'left_bottom', key: 'left_people_bottom', val: 0, bgColor: UNRELATED, locked: false },
                ],
            ]},
            {type: 'intersection'},
            {type: 'portrait-data-right', row: [
                [
                    {type: 'people', direction: 'right_top', key: 'right_people_top', val: 0, bgColor: UNRELATED, locked: false }
                ],
                [
                    {type: 'people', direction: 'right_left', key: 'right_people_left', val: 0, bgColor: UNRELATED, locked: false }
                ],
                [
                    {type: 'people', direction: 'right_bottom', key: 'right_people_bottom', val: 0, bgColor: UNRELATED, locked: false }
                ]
            ]},
        ],
        [
            {type: 'color'},
            {type: 'landscape-data-bottom', row: [
                [
                    {type: 'people', direction: 'bottom_left', key: 'bottom_people_left', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'bottom_top', key: 'bottom_people_top', val: 0, bgColor: UNRELATED, locked: false },
                    {type: 'people', direction: 'bottom_right', key: 'bottom_people_right', val: 0, bgColor: UNRELATED, locked: false },
                ],
            ]},
            {type: 'icon'},
        ]
    ]
}


export const screenCountList = (data: any) => {
    return [
        [
            {type: 'blank'},
            {type: 'landscape-data-top', row: [
                [
                    {type: 'car', direction: 'top_left', key: 'top_car_left', val: data.top_car_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'top_bottom', key: 'top_car_bottom', val: data.top_car_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'top_right', key: 'top_car_right', val: data.top_car_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'people', direction: 'top_left', key: 'top_people_left', val: data.top_people_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'top_bottom', key: 'top_people_bottom', val: data.top_people_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'top_right', key: 'top_people_right', val: data.top_people_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ]
            ]},
            {type: 'common_uncommon', car: 'true', people: 'true' },
        ],
        [
            {type: 'portrait-data-left', row: [
                [
                    {type: 'car', direction: 'left_top', key: 'left_car_top',val: data.left_car_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'left_top', key: 'left_people_top',val: data.left_people_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'car', direction: 'left_right', key: 'left_car_right', val: data.left_car_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'left_right', key: 'left_people_right', val: data.left_people_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'car', direction: 'left_bottom', key: 'left_car_bottom', val: data.left_car_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'left_bottom', key: 'left_people_bottom', val: data.left_people_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
            ]},
            {type: 'intersection'},
            {type: 'portrait-data-right', row: [
                [
                    {type: 'people', direction: 'right_top', key: 'right_people_top', val: data.right_people_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'right_top', key: 'right_car_top', val: data.right_car_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount }
                ],
                [
                    {type: 'people', direction: 'right_left', key: 'right_people_left', val: data.right_people_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'right_left', key: 'right_car_left', val: data.right_car_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount }
                ],
                [
                    {type: 'people', direction: 'right_bottom', key: 'right_people_bottom', val: data.right_people_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'right_bottom', key: 'right_car_bottom', val: data.right_car_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount }
                ]
            ]},
        ],
        [
            {type: 'color'},
            {type: 'landscape-data-bottom', row: [
                [
                    {type: 'people', direction: 'bottom_left', key: 'bottom_people_left', val: data.bottom_people_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'bottom_top', key: 'bottom_people_top', val: data.bottom_people_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'bottom_right', key: 'bottom_people_right', val: data.bottom_people_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'car', direction: 'bottom_left', key: 'bottom_car_left', val: data.bottom_car_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'bottom_top', key: 'bottom_car_top', val: data.bottom_car_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'bottom_right', key: 'bottom_car_right', val: data.bottom_car_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ]
            ]},
            {type: 'icon'},
        ]
    ]
}

export const screenCarCountList = (data: any) => {
    return [
        [
            {type: 'blank'},
            {type: 'landscape-data-top', row: [
                [
                    {type: 'car', direction: 'top_left', key: 'top_car_left', val: data.top_car_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'top_bottom', key: 'top_car_bottom', val: data.top_car_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'top_right', key: 'top_car_right', val: data.top_car_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
            ]},
            {type: 'common_uncommon', car: 'true', people: 'true' },
        ],
        [
            {type: 'portrait-data-left', row: [
                [
                    {type: 'car', direction: 'left_top', key: 'left_car_top',val: data.left_car_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'car', direction: 'left_right', key: 'left_car_right', val: data.left_car_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'car', direction: 'left_bottom', key: 'left_car_bottom', val: data.left_car_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
            ]},
            {type: 'intersection'},
            {type: 'portrait-data-right', row: [
                [
                    {type: 'car', direction: 'right_top', key: 'right_car_top', val: data.right_car_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount }
                ],
                [
                    {type: 'car', direction: 'right_left', key: 'right_car_left', val: data.right_car_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount }
                ],
                [
                    {type: 'car', direction: 'right_bottom', key: 'right_car_bottom', val: data.right_car_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount }
                ]
            ]},
        ],
        [
            {type: 'color'},
            {type: 'landscape-data-bottom', row: [
                [
                    {type: 'car', direction: 'bottom_left', key: 'bottom_car_left', val: data.bottom_car_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'bottom_top', key: 'bottom_car_top', val: data.bottom_car_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'car', direction: 'bottom_right', key: 'bottom_car_right', val: data.bottom_car_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ]
            ]},
            {type: 'icon'},
        ]
    ]
}

export const screenPeopleCountList = (data: any) => {
    return [
        [
            {type: 'blank'},
            {type: 'landscape-data-top', row: [
                [
                    {type: 'people', direction: 'top_left', key: 'top_people_left', val: data.top_people_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'top_bottom', key: 'top_people_bottom', val: data.top_people_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'top_right', key: 'top_people_right', val: data.top_people_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ]
            ]},
            {type: 'common_uncommon', car: 'true', people: 'true' },
        ],
        [
            {type: 'portrait-data-left', row: [
                [
                    {type: 'people', direction: 'left_top', key: 'left_people_top',val: data.left_people_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'people', direction: 'left_right', key: 'left_people_right', val: data.left_people_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'people', direction: 'left_bottom', key: 'left_people_bottom', val: data.left_people_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
            ]},
            {type: 'intersection'},
            {type: 'portrait-data-right', row: [
                [
                    {type: 'people', direction: 'right_top', key: 'right_people_top', val: data.right_people_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'people', direction: 'right_left', key: 'right_people_left', val: data.right_people_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
                [
                    {type: 'people', direction: 'right_bottom', key: 'right_people_bottom', val: data.right_people_bottom, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ]
            ]},
        ],
        [
            {type: 'color'},
            {type: 'landscape-data-bottom', row: [
                [
                    {type: 'people', direction: 'bottom_left', key: 'bottom_people_left', val: data.bottom_people_left, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'bottom_top', key: 'bottom_people_top', val: data.bottom_people_top, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                    {type: 'people', direction: 'bottom_right', key: 'bottom_people_right', val: data.bottom_people_right, bgColor: UNRELATED, locked: false, intersectionCount: data.intersectionCount },
                ],
            ]},
            {type: 'icon'},
        ]
    ]
}

export interface impactCounterType {
    uuid: string;
    latitude: number;
    longitude: number;
    shape: string;
    name: string;
    count_time: number;
    top_car_left: number;
    top_car_bottom: number;
    top_car_right: number;
    top_people_left: number;
    top_people_bottom: number;
    top_people_right: number;
    left_car_top: number;
    left_car_bottom: number;
    left_car_right: number;
    left_people_top: number;
    left_people_bottom: number;
    left_people_right: number;
    bottom_car_top: number;
    bottom_car_left: number;
    bottom_car_right: number;
    bottom_people_top: number;
    bottom_people_left: number;
    bottom_people_right: number;
    right_car_top: number;
    right_car_left: number;
    right_car_bottom: number;
    right_people_top: number;
    right_people_left: number;
    display_date: string;
  }
  
export interface impactCounterInterFace {
    key: string,
    data: any,
    arrowPoly: google.maps.Polyline,
}

export const redColor = "#FF0000"
export const down = "<<"
export const shortDown = "<"
export const zero = "△"
export const up = ">"
export const lergeUp = ">>"
  